var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87863 8.94921L11.6844 6.14344L2.62187 1.04998C2.02124 0.725467 1.45857 0.679922 0.965166 1.03479L8.87863 8.94921ZM12.1626 12.2342L15.0794 10.5936C15.6487 10.2748 15.9609 9.82311 15.9609 9.32211C15.9609 8.82206 15.6487 8.36946 15.0804 8.05064L12.4397 6.56758L9.46692 9.5394L12.1626 12.2342ZM0.477454 1.72461C0.416727 1.91154 0.382568 2.12029 0.382568 2.34896V16.3019C0.382568 16.6634 0.462272 16.9746 0.606499 17.2223L8.28939 9.53845L0.477454 1.72461ZM8.87863 10.1267L1.23844 17.7679C1.38456 17.8239 1.54207 17.8533 1.70812 17.8533C2.00416 17.8533 2.31254 17.766 2.62661 17.5914L11.4083 12.6602L8.87863 10.1267Z",
    fill: "#025F4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/playStore.2a0e0c4ad5efd6d40ed3b16b31a40c94.svg";
export { ForwardRef as ReactComponent };